// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__35paO","info":"Note_info__2dBTh","note":"Note_note__3imrq","actions":"Note_actions__GHZub"};